import queryString from "query-string";
import { useSearchParams } from "react-router-dom";
import { SEPARATE_ARR_CHARACTER } from "scripts/constants";

export const useOnChangeFilter = () => {
  const [_searchParams, setSearchParams] = useSearchParams();
  return (currentQuery?: any) => {
    setSearchParams(
      queryString?.stringify(currentQuery, {
        arrayFormat: "separator",
        arrayFormatSeparator: SEPARATE_ARR_CHARACTER,
      }),
      {
        replace: true,
      },
    );
  };
};

export default useOnChangeFilter;
